'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.collapseDocumentElementOrder = exports.buildDocumentModeData = exports.buildTopLevelClusterData = exports.buildColumnClusterData = exports.buildElementClusterData = undefined;

var _lodash = require('lodash');

var _clusterBuilder = require('./clusterBuilder');

var clusterBuilder = _interopRequireWildcard(_clusterBuilder);

var _clusterSorter = require('./clusterSorter');

var clusterSorter = _interopRequireWildcard(_clusterSorter);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } // Lib


// Utils


/**
 * Builds the element level (leaf) cluster data.
 */
var buildElementClusterData = exports.buildElementClusterData = function buildElementClusterData(elementCluster) {
    return {
        cluster: elementCluster
    };
};

/**
 * Builds the column level cluster data which includes sorted element children and data relating to how the children
 * were sorted.
 */
var buildColumnClusterData = exports.buildColumnClusterData = function buildColumnClusterData(columnCluster) {
    var orderedElementsData = clusterSorter.columnElementsSort(columnCluster);
    var children = orderedElementsData.sortedClusters.map(buildElementClusterData);

    return {
        cluster: columnCluster,
        readingData: orderedElementsData.readingLines,
        children: children
    };
};

/**
 * Builds the top level cluster which includes column clusters as children and the data relating to how those columns
 * were found and sorted.
 */
var buildTopLevelClusterData = exports.buildTopLevelClusterData = function buildTopLevelClusterData(topLevelCluster) {
    var columnClusterSearchData = clusterBuilder.findColumnClusters(topLevelCluster);
    var sortedColumnClustersData = clusterSorter.columnSort(columnClusterSearchData.clusters);
    var children = sortedColumnClustersData.sortedClusters.map(buildColumnClusterData);

    return {
        cluster: topLevelCluster,
        dendrogramData: columnClusterSearchData.dendrogramData,
        elbowPointData: columnClusterSearchData.elbowPointData,
        readingData: sortedColumnClustersData.readingLines,
        children: children
    };
};

/**
 * Builds the document mode data which includes the top level clusters as children (which in turn have column children
 * which have element children) as well as the data relating to how the top level clusters were found and sorted.
 */
var buildDocumentModeData = exports.buildDocumentModeData = function buildDocumentModeData(documentElements) {
    // First level clusters
    var topLevelClusterSearchData = clusterBuilder.findTopLevelClusters(documentElements);
    var sortedClusterData = clusterSorter.naturalReadingSort(topLevelClusterSearchData.clusters);
    var children = sortedClusterData.sortedClusters.map(buildTopLevelClusterData);

    return {
        dendrogramData: topLevelClusterSearchData.dendrogramData,
        elbowPointData: topLevelClusterSearchData.elbowPointData,
        earlyExit: topLevelClusterSearchData.earlyExit,
        readingData: sortedClusterData.readingLines,
        children: children
    };
};

var collapseDocumentElementOrder = exports.collapseDocumentElementOrder = function collapseDocumentElementOrder(documentModeData) {
    return _lodash.concat.apply(undefined, [[]].concat(_toConsumableArray(documentModeData.children.map(function (topLevelClusterData) {
        return _lodash.concat.apply(undefined, [[]].concat(_toConsumableArray(topLevelClusterData.children.map(function (columnClusterData) {
            return columnClusterData.children.map(function (elementCluster) {
                return elementCluster.cluster.id;
            });
        }))));
    }))));
};


//////////////////
// WEBPACK FOOTER
// ./src/common/documentOrder/documentOrderDataBuilder.js
// module id = 2260
// module chunks = 0